export const DefaultTimelineSegmentSize = 200;
